import Button from '@doordash/component-button'
import { Colors, StackChildren, Text } from '@doordash/design-language'
import * as React from 'react'
import { i18nKeys } from 'translationTypes'
import {
  ConfirmationStepKeys,
  ConfirmationStepTrackingKeys,
} from '../../../constants'
import i18n from '../../../i18n'

interface AbnStepProps {
  /**
   * transient props - not used within this component
   * Needed for use within dropshipping-status
   */
  alwaysEnabled?: boolean
  generateTitle?: (isComplete: boolean) => string
  step?: ConfirmationStepTrackingKeys
  completeKey?: ConfirmationStepKeys
  onAddAbnClick: () => void
}

function AbnStep({ onAddAbnClick }: AbnStepProps) {
  return (
    <StackChildren>
      <Text
        tag="p"
        styles={Text.Styles.SectionSubtext}
        color={Colors.SystemGrey80}
      >
        {i18n.t(i18nKeys.backgroundCheck__progress__addAbnText)}
      </Text>
      <Button
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Small}
        tag="a"
        onClick={onAddAbnClick}
        isInline
      >
        {i18n.t(i18nKeys.backgroundCheck__progress__addAbnButton)}
      </Button>
    </StackChildren>
  )
}

export default AbnStep
